export default "__VITE_ASSET__DIjl6maE__"